export default "__VITE_ASSET__Bgo5o0fG__$_?url__"